module.exports = __webpack_public_path__ + "assets/img/bg_start.59a5c210.svg";